import { CHERRY_DEV } from '../CherrySoftware/cherryDevBrand';

export { CHERRY_DEV };

/** Paleta Farmafer: farmacia / confianza / frescura (independiente del cream-cherry genérico). */
export const FARMA = {
  green: '#0A6B4A',
  greenDeep: '#064A34',
  greenSoft: '#1A8F64',
  mint: '#E6F4EE',
  mist: '#F3FAF6',
  ink: '#10241C',
  inkMuted: '#3D5A4C',
  sand: '#E8EDE9',
  white: '#FFFFFF',
  accent: '#B8860B',
};

const BRAND_NAME = 'cherryDev';
const CLIENT_NAME = 'Farmafer';
const CLIENT_CONTACT = 'Jose Luis';

export const WHATSAPP_PHONE =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_CHERRY_SOFTWARE_WHATSAPP_PHONE) ||
  '';

export const WHATSAPP_DEFAULT = `Hola ${BRAND_NAME}, soy ${CLIENT_CONTACT} de ${CLIENT_NAME}. Ya revisé la propuesta: envío el comprobante del pago y el link de Google Drive con el material (compartido con karolscript@gmail.com).`;

export const PAGE_TITLE = `${BRAND_NAME} × ${CLIENT_NAME} | Propuesta e-commerce`;
export const PAGE_DESCRIPTION =
  'Propuesta formal cherryDev para Farmafer: tienda online con catálogo, pedidos por WhatsApp, dominio y hosting. Inversión total $130 USD.';

export const HERO_IMAGE =
  'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?auto=format&fit=crop&w=1920&q=80';

export const hero = {
  brand: BRAND_NAME,
  clientName: CLIENT_NAME,
  clientContact: CLIENT_CONTACT,
  overline: 'Propuesta formal · Digitalización',
  title: 'Tu nueva sucursal digital, abierta 24/7.',
  subtitle:
    'No estás comprando una página web: estás invirtiendo en un activo que vende mientras duermes, posiciona Farmafer frente a la competencia y le da a tus clientes la inmediatez que hoy exigen.',
  cta: 'Ver inversión y estructura',
  congrats: `Excelente decisión, ${CLIENT_CONTACT}.`,
};

export const structure = {
  overline: 'Plataforma',
  title: 'Estructura de tu tienda online',
  subtitle:
    'Cuatro módulos pensados para que Farmafer venda, genere confianza y cierre pedidos sin fricción.',
  modules: [
    {
      id: 'home',
      title: 'Inicio',
      text:
        'Banner principal para promociones del mes, acceso rápido a categorías estrella (Medicamentos, Primeros Auxilios, Cuidado Personal) y carrusel de productos destacados.',
    },
    {
      id: 'catalogo',
      title: 'Catálogo e-commerce',
      text:
        'Tienda completa con buscador, fotos, descripciones, precios y pasarela de pedido: el cliente arma el carrito y el requerimiento te llega directo a WhatsApp listo para despachar.',
    },
    {
      id: 'sobre',
      title: 'Sobre Farmafer',
      text:
        'Espacio breve para transmitir confianza: atención, seguridad y trayectoria de la farmacia.',
    },
    {
      id: 'contacto',
      title: 'Contacto y ubicación',
      text:
        'Botón flotante de WhatsApp en toda la web, ubicación en Google Maps y horarios de servicio.',
    },
  ],
};

export const investment = {
  overline: 'Inversión promocional',
  title: 'Una inversión clara, sin sorpresas',
  subtitle: 'Alcance completo para poner Farmafer online esta misma semana.',
  lines: [
    { id: 'platform', label: 'Plataforma e-commerce completa', amount: 120 },
    { id: 'hosting', label: 'Dominio y hosting (1er año)', amount: 10 },
  ],
  total: 130,
  currency: 'USD',
  note: 'Total a cancelar para bloquear el cupo y arrancar la construcción.',
};

export const payment = {
  overline: 'Formalización',
  title: 'Métodos de pago',
  subtitle: 'Toca Copiar en el dato que necesites. Queda listo en el portapapeles.',
  methods: [
    {
      id: 'zelle',
      name: 'Zelle',
      fields: [{ label: 'Correo', value: 'loreanaquino53@gmail.com' }],
    },
    {
      id: 'binance',
      name: 'Binance',
      fields: [{ label: 'Correo / Pay ID', value: 'karolyntno@gmail.com' }],
    },
    {
      id: 'zinli',
      name: 'Zinli',
      fields: [{ label: 'Correo', value: 'karolyntno@gmail.com' }],
    },
    {
      id: 'pagomovil',
      name: 'Pago Móvil (Bs a tasa promedio)',
      fields: [
        {
          label: 'Datos completos',
          value: 'Karolyn Méndez · CI 166444576 · 04123964576 · Banesco',
        },
      ],
    },
  ],
};

export const nextSteps = {
  overline: 'Siguientes pasos',
  title: 'Así formalizamos y arrancamos',
  subtitle: 'Pago, material en Drive y listo: Farmafer entra en producción.',
  driveEmail: 'karolscript@gmail.com',
  steps: [
    {
      id: 'pago',
      n: '01',
      title: 'Pago y comprobante',
      text: 'Realiza el pago y envíanos el comprobante por WhatsApp para bloquear tu cupo de inmediato.',
    },
    {
      id: 'drive',
      n: '02',
      title: 'Sube todo el material a Google Drive',
      text:
        'Crea una carpeta con el material de Farmafer, compártela con acceso de editor o lector a karolscript@gmail.com y pásanos el link por WhatsApp.',
      materials: [
        'Logo en alta calidad (PNG/SVG preferible; también JPG si es lo que hay)',
        'Manual de marca, si lo tienes (colores, tipografías, usos del logo)',
        'Fotos de productos (claras, fondo limpio si es posible)',
        'Listado de primeros productos: nombre, descripción corta, precio y categoría',
        'Categorías estrella (ej. Medicamentos, Primeros Auxilios, Cuidado Personal)',
        'Datos de contacto: WhatsApp de pedidos, teléfono, correo y redes sociales',
        'Ubicación (dirección o link de Google Maps) y horarios de servicio',
        'Textos de Sobre Farmafer (o bullets de trayectoria / promesa de marca)',
        'Banners o promociones del mes, si ya los tienes',
      ],
    },
    {
      id: 'arranque',
      n: '03',
      title: 'Confirmación y arranque',
      text: 'Con el pago y el link de Drive, bloqueamos el cupo y empezamos a construir la tienda esta misma semana.',
    },
  ],
  cta: 'Enviar comprobante por WhatsApp',
  copyright: `© ${new Date().getFullYear()} ${BRAND_NAME} · Propuesta para ${CLIENT_NAME}`,
};
